import { testIds } from '@/ui/utils/testIds'
import { ActivityStats } from '../../logic/useActivity'
import { SummaryTile } from './SummaryTile'

interface SummaryTilesProps {
  activityStats: ActivityStats
}

export function SummaryTiles({ activityStats }: SummaryTilesProps) {
  let index = 0

  return (
    <div className="flex justify-between gap-12 md:justify-start lg:gap-24">
      <SummaryTile
        variant="total-liquidation"
        USDValue={activityStats.totalLiquidationUSD}
        data-testid={testIds.markets.summary.tile(index++)}
      />
    </div>
  )
}
